<gp-contract-data
  *ngIf="essService.employee"
  [selectedContract]="selectedContract"
  [employeeFirstName]="essService.employee?.firstName"
  [employeeLastName]="essService.employee?.lastName"
  [photoLink]="essService.employee?.photoLink"
  [contracts]="essService.employee?.contracts"
  [cliEmpId]="essService.employee?.id"
  [workflowName]="workflowName"
  [profileType]="essProfileType"
  [profileMode]="profileMode">
</gp-contract-data>
